import React, { useEffect, useState } from 'react';
import { Modal, Nav, Tab } from 'react-bootstrap';
import { CartAdd, CartRmv } from "../../store/actions/CartActions"
import { calculateDiscountPercentage } from '../helpers/helpers'
import SwiperCTNProducts  from "../layouts/SwiperCTNProducts"
import { productsPublicShop } from "../../services/ProductService"
import tabData from './subtabs/tabDataMain.json'

const MenuOut = () => {
    let dummy = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')) : {
        cart: {
            loja: "",
            status: "aguardando",
            itens: []
        }
    }
    let cartToken = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')) : { cart: {} }
    
    const [loading, setLoading] = useState(true)
    const [shopper, setShopper] = useState({});
    const [isBuying, setIsBuying] = useState(false);
    const [products, setProducts] = useState([])
    const [product, setProduct] = useState({})
    const [shopperId, setShopperId] = useState('-')
    const [qtd, setQtd] = useState(0);
    const [lojaSelecionada, setLojaSelecionada] = useState(cartToken.cart.loja);
    const [modalShow, setModalShow] = useState(false);
    const [modalProduct, setModalProduct] = useState(false);
    const [cart, setCart] = useState(dummy);
    const [isLargeScreen,] = useState(window.innerWidth > 700);

    const [productNameSearch, setProductNameSearch] = useState('');
    const [onSearch, setOsSearch] = useState(false);
    const [lastSearch, setLastSearch] = useState('');
    const [searchSteps, setSearchSteps] = useState('name');
    const [modalSearch, setModalSearch] = useState(false);
    const [searchValueType, setValueType] = useState('name');

    const getURLVariable = (variable) => {
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        console.error('Variável da URL não encontrada: ' + variable);
        return null;
    };

    const qtfcr = (ope, data) => {
        let cartDummy = JSON.parse(localStorage.getItem('cart'))
        if (!cartDummy || !cartDummy.cart.loja || !cartDummy.cart.loja.id) {
            setModalShow(true);
        } else {
            if (ope === 'plus') {
                let dummyValue = CartAdd(data)
                setCart(dummyValue)
            } else if (ope === 'minus') {
                let dummyValue = CartRmv(data)
                setCart(dummyValue)
            }
        }
    };

    // Função para ordenar produtos conforme a lista fornecida
    const ordemProdutos = [
        // Pipoca
        "Pipoca Amarela 100g Tamanho Família",
        "Pipoca Branca 100g Tamanho Família",
        "Pipoca Amarela 30g",
        "Pipoca Doce 30g",
        "Pipoca Branca 30g",
        "Pipoca Amarela 15g",
        "Pipoca Branca 15g",
        // Salgadinhos de Milho
        "Queijo 80g",
        "Cebola na Brasa 80g",
        "Churrasco 80g",
        "Galinha Caipira 80g",
        "Manteiga 30g",
        "Queijo 30g",
        "Cebola 30g",
        "Pizza 30g",
        "Churrasco 30g",
        "Presunto  30g",
        "Galinha Caipira 30g",
        "Pastel de Carne 30g",
        "Bacon  30g",
        "Queijo 12g",
        "Cebola 12g",
        "Churrasco 12g",
        "Galinha caipira 12g",
        // Pellets de Trigo
        "Pellet Bacon 35g",
        "Pellet Costela Suína 35g",
    ];
    function ordenarProdutosPorNome(produtos) {
        return produtos.slice().sort((a, b) => {
            const idxA = ordemProdutos.findIndex(nome => nome.trim().toLowerCase() === a.name.trim().toLowerCase());
            const idxB = ordemProdutos.findIndex(nome => nome.trim().toLowerCase() === b.name.trim().toLowerCase());
            if (idxA === -1 && idxB === -1) return 0;
            if (idxA === -1) return 1;
            if (idxB === -1) return -1;
            return idxA - idxB;
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await productsPublicShop();
                if (response.status === 200) {
                    const result = response.data.result;
                    if (result && result.store) {
                        setShopper(result.store);
                    }
                    if (result && result.products) {
                        // Ordenar produtos conforme a lista
                        setProducts(ordenarProdutosPorNome(result.products));
                    }
                    setLoading(false);
                }
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (shopperId !== '-') {
            const selectedProduct = products.find(p => p.id === shopperId);
            if (selectedProduct) {
                setProduct(selectedProduct);
                setModalProduct(true);
            }
        }
    }, [shopperId, products]);

    useEffect(() => {
        let dummy = JSON.stringify(cart)
        localStorage.setItem('cart', dummy)
    }, [cart]);

    useEffect(() => {
        const cartData = JSON.parse(localStorage.getItem('cart'));
        if (cartData?.cart?.loja?.id) {
            setIsBuying(true);
        }
    }, []);

    const shopConfirm = () => {
        const cartDummy = JSON.parse(localStorage.getItem('cart')) || {};
        cartDummy.cart = cartDummy.cart || {};
        
        if (shopper && shopper.id) {
            cartDummy.cart.loja = shopper;
            cartDummy.cart.status = 'em uso';
            cartDummy.cart.itens = [];
            localStorage.setItem('cart', JSON.stringify(cartDummy));
            setIsBuying(true);
            setModalShow(false);
        }
    };

    useEffect(() => {
        if (localStorage.cart) {
            const cartDummy = JSON.parse(localStorage.cart);
            let somaQuantidades = 0;
            if (cartDummy.cart.itens && cartDummy.cart.itens.length > 0) {
                cartDummy.cart.itens.forEach(item => {
                    if (item.hasOwnProperty('quantidade')) {
                        somaQuantidades += item.quantidade;
                    }
                });
            }
            setQtd(somaQuantidades);
        } else {
            setQtd(0);
        }
    }, [cart]);

    const handleStoreFilter = ( value, Page, PerPage ) => {
        const storeFilter = async () => {
           try {
              const response = await productsPublicShop(value, Page, PerPage);
              if (response.status === 200) {
                 setProducts(response.data.result);
                 setOsSearch(true);
                 setLastSearch(value);
                 setModalSearch(false);
              }
           } catch (error) {
              console.error("Erro ao filtrar lojas:", error);
           }
        };
        storeFilter();
    }; 

    const lojaId = localStorage.cart ? JSON.parse(localStorage.cart) : { cart: {} }

    // IDs e nomes das categorias (Pipoca primeiro)
    const categorias = [
        { id: "d34e4917-4cdb-442e-90e8-e68adc781807", nome: "Pipoca" },
        { id: "54bd475f-7438-49fb-9967-ef0d2ba32c46", nome: "Salgadinho de Milho" },
        { id: "219cbfd3-dc40-4547-ba16-b68ee3cbb758", nome: "Salgadinho de Trigo" },
    ];
    // Pesos do mais pesado para o mais leve
    const pesos = [100, 80, 35, 30, 15, 12];

    // Função para mapear o nome da categoria para o título exibido
    const nomeCategoriaExibicao = {
        'd34e4917-4cdb-442e-90e8-e68adc781807': 'PIPOCA',
        '54bd475f-7438-49fb-9967-ef0d2ba32c46': 'SALGADINHO DE MILHO',
        '219cbfd3-dc40-4547-ba16-b68ee3cbb758': 'PELLET DE TRIGO',       
    };

    const nomeCategoriaExibicaoTitle = {
        'd34e4917-4cdb-442e-90e8-e68adc781807': 'PIPOCAS',
        '54bd475f-7438-49fb-9967-ef0d2ba32c46': 'SALGADINHOS DE MILHO',
        '219cbfd3-dc40-4547-ba16-b68ee3cbb758': 'PELLETS DE TRIGO',
    };

    // Função para obter a quantidade de um produto no carrinho
    const getQtdInCart = (productId) => {
        const cartDummy = JSON.parse(localStorage.getItem('cart'));
        if (cartDummy && cartDummy.cart && cartDummy.cart.itens) {
            const item = cartDummy.cart.itens.find(i => i.produto && i.produto.id === productId);
            return item ? item.quantidade : 0;
        }
        return 0;
    };

    useEffect(() => {
        console.log('shopConfirm() - 1');
        if (shopper && shopper.id) {
            shopConfirm();
            console.log('shopConfirm() - 2');
        } 
    }, [shopper]);    

    return (
        <>
            {
                qtd !== 0 ?
                    <span style={{ display: 'flex', justifyContent: 'center', position: 'absolute', left: 'Calc(50% + 65px)', top: '97px', zIndex: '9999', width: 20, height: 20, position: 'fixed', backgroundColor: '#f54749', marginRight: -150, borderRadius: '100%', fontSize: 12, paddingTop: 2, color: 'white', }}>
                        {qtd}
                    </span>
                    : qtd === 0 ?
                        null
                        : null
            }
            
            <div className="row" style={{flexDirection: 'column' , gap: '27px'}}>
                {
                    lojaSelecionada !== null ?
                        <div className="col-xl-12" style={{ maxWidth: '400px', margin: '0 auto' }}>
                            <br />
                            {shopper.deliveryTax > 0?
                                <span className='d-flex flex-wrap flex-column justify-content-center'>
                                    <div style={{width: 130 , margin: '0 auto' , textAlign: 'center'}}>
                                        taxa de entrega:
                                        <h3 style={{ margin: 0, padding: 4, borderRadius: 4, backgroundColor: 'rgb(182 196 255)' }}>{shopper.deliveryTax.toFixed(2)} RS</h3>
                                    </div>
                                </span>
                            :<span className='d-flex flex-wrap flex-column justify-content-center text-center'>
                                <span style={{backgroundColor: '#dedede', padding: 6}}>
                                    sem taxa de entrega
                                </span>
                            </span>
                            }
                        </div>
                        : null
                }
                

                <div className="col-xl-12" style={{ padding: 0 }}>
                    {products.length !== 0 ? (
                        isLargeScreen ? (
                            categorias.map((cat) => {
                                const pesosDisponiveis = pesos.filter(peso => products.some(p => p.categoryId === cat.id && p.weight === peso && p.stock !== 0));
                                if (pesosDisponiveis.length === 0) return null;
                                return (
                                    <div key={cat.id} style={{ marginBottom: 32 }}>
                                        <h3 style={{ padding: '8px', borderRadius: '3px', backgroundColor: 'rgb(60 84 255)', color: 'white', textAlign: 'center', margin: '16px 0 8px 0', textTransform: 'uppercase', letterSpacing: 1 }}>{nomeCategoriaExibicaoTitle[cat.id]}</h3>
                                        <ul className="btn-reveal-trigger row" style={{ padding: 0 }}>
                                            {pesosDisponiveis.map((peso) => {
                                                const produtosFiltrados = products.filter(
                                                    (Data) => Data.weight === peso && Data.stock !== 0 && Data.categoryId === cat.id
                                                );
                                                if (produtosFiltrados.length === 0) return null;
                                                return (
                                                    <React.Fragment key={peso}>
                                                        {/* Removido o título de peso */}
                                                        {produtosFiltrados.map((Data) => (
                                                            <li className="col-sm-6 col-md-4" style={{ marginBottom: 6, borderRadius: 6 }} key={Data.id}>
                                                                <div className="p-3" style={{ boxShadow: 'rgb(177 177 177) 1px 1px 4px' }}>
                                                                    <span style={{ display: 'flex', flexDirection: 'column', gap: 3, position: 'relative' }}>
                                                                        {Data.images.length > 0 ? (
                                                                            <img className="" style={{ width: '100%' }} src={'https://core.pskeromais.com.br/' + Data.images[0].url} />
                                                                        ) : (
                                                                            <span style={{ width: '100%', height: 200, backgroundImage: "gray", margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)' }}>
                                                                                <i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
                                                                            </span>
                                                                        )}
                                                                        <span className="mb-0 fs--1" style={{ width: '100%', textAlign: 'center' , fontSize: 10 }}>pack com 10 unid.</span>
                                                                        <div style={{ width: '100%' }}><br />
                                                                            <h3 className="mb-0 fs--1" style={{ width: '100%', textAlign: 'center' }}>{Data.name}, {Data.weight}g</h3>
                                                                            <span style={{ fontSize: '15px', fontWeight: 'bold', margin: '4px auto', display: 'block', textAlign: 'center' }}>{nomeCategoriaExibicao[cat.id]}</span>
                                                                        </div>
                                                                        <span style={{ maxWidth: '100px', width: '100%', margin: '6px auto', backgroundColor: 'rgb(241, 241, 241)', padding: 6, borderRadius: '3px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column", position: 'relative' }}>
                                                                            {Data.salePrice > Data.onSalePrice ? (
                                                                                <i style={{ margin: '0 4px', textDecoration: 'line-through', color: '#a0a0a0' }}>{Data.salePrice.toFixed(2) + ' R$'}</i>
                                                                            ) : null}
                                                                            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{Data.onSalePrice.toFixed(2) + ' R$'}</span>
                                                                            {/*Data.salePrice > Data.onSalePrice ? (
                                                                                <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontWeight: 'bold', backgroundColor: '#F54749', color: 'white', width: 60, height: 60, padding: 10, borderRadius: '100%', fontSize: 18, position: 'absolute', top: '-15px', right: '-40px' }}>
                                                                                    <span style={{ height: '18px' }}>{calculateDiscountPercentage(Data.salePrice, Data.onSalePrice) + '%'}</span>
                                                                                    <span style={{ height: '18px', fontWeight: 'normal' }}>OFF</span>
                                                                                </span>
                                                                            ) : null*/}
                                                                        </span>
                                                                    </span>
                                                                    {isBuying ? (
                                                                        <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                            <button onClick={() => qtfcr('minus', Data)} className="btn btn-primary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                                <i className="bi bi-dash" style={{ fontSize: 20 }}></i>
                                                                            </button>
                                                                            <span style={{ 
                                                            minWidth: 36, 
                                                            minHeight: 36, 
                                                            width: 38, 
                                                            height: 38, 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center', 
                                                            borderRadius: '50%', 
                                                            background: '#e0e0e0', 
                                                            fontWeight: 'bold', 
                                                            fontSize: 22, 
                                                            color: '#333',
                                                            margin: '0 6px',
                                                            border: '2px solid #bdbdbd',
                                                        }}>{getQtdInCart(Data.id)}</span>
                                                                            <button onClick={() => qtfcr('plus', Data)} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                                <i className="bi bi-plus" style={{ fontSize: 20 }}></i>
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                            <button onClick={() => setModalShow(!modalShow)} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto">
                                                                                fazer pedido
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                    <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                        <button onClick={() => setShopperId(Data.id)} className="btn btn-primary-outline border border-primary text-primary py-1 px-3 mt-2 mr-auto ml-auto" style={{ maxWidth: 100 }}>
                                                                            produto
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                );
                            })
                        ) : (
                            categorias.map((cat) => {
                                const pesosDisponiveis = pesos.filter(peso => products.some(p => p.categoryId === cat.id && p.weight === peso && p.stock !== 0));
                                if (pesosDisponiveis.length === 0) return null;
                                return (
                                    <div key={cat.id} style={{ marginBottom: 32 }}>
                                        <h3 style={{ padding: '8px', borderRadius: '3px', backgroundColor: 'rgb(60 84 255)', color: 'white', textAlign: 'center', margin: '16px 0 8px 0', textTransform: 'uppercase', letterSpacing: 1 }}>{nomeCategoriaExibicao[cat.id]}</h3>
                                        {pesosDisponiveis.map((peso) => {
                                            const produtosFiltrados = products.filter(
                                                (product) => product.weight === peso && product.stock !== 0 && product.categoryId === cat.id
                                            );
                                            if (produtosFiltrados.length === 0) return null;
                                            return (
                                                <React.Fragment key={peso}>
                                                    {/* Removido o título de peso */}
                                                    <SwiperCTNProducts products={produtosFiltrados.map(prod => ({...prod, name: prod.name + ', ' + prod.weight + 'g'}))} setModalShows={() => setModalShow(!modalShow)} isBuying={isBuying} qtfcrMinus={(Data) => qtfcr('minus', Data)} qtfcrPlus={(Data) => qtfcr('plus', Data)} getQtdInCart={getQtdInCart}/>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                );
                            })
                        )
                    ) : null}
                </div>
            </div>
            <Modal className="custom-modal fade d-flex align-items-center justify-content-center " show={modalShow}>
                <button onClick={() => setModalShow(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <i className="bi bi-basket" style={{ fontSize: 30 }}></i>
                    <h2>inciar compras?</h2>
                    <br />
                    <div onClick={() => setModalShow(false)} className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => shopConfirm()} className='btn btn-primary'>
                            começar compras
                        </button>
                        <button className='btn btn-light'>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal className="custom-modal fade d-flex align-items-center justify-content-center " show={modalProduct}>
                <button onClick={() => { setModalProduct(false); setShopperId('-') }} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    {product.name ?
                        <>
                            <div className="p-3">
                                <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    {
                                        product.images.length > 0 ?
                                            <img className="" style={{ width: 130 }} src={'https://core.pskeromais.com.br/' + product.images[0].url} />
                                            : <span style={{
                                                width: 130,
                                                height: 80,
                                                backgroundImage: "gray",
                                                margin: '0 auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)'
                                            }}>
                                                <i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
                                            </span>
                                    }
                                </span>
                            </div>
                            <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <div className="media d-flex justify-content-between">
                                    <div>
                                        <br />
                                        <h3 className="mb-0 fs--1">
                                            {product.name}
                                        </h3>
                                    </div>
                                </div>
                                <hr />
                                <p style={{ textIndent: '24px', textAlign: 'justify' }}>
                                    {product.description}
                                </p>
                                <span style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                    <span>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-stack" ></i> peso
                                        </span>
                                        <br />
                                        <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                            {product.weight + ' g'}
                                        </span>
                                    </span>
                                    <span>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-wallet2"></i> preço:
                                        </span>
                                        <span style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                                            <span style={{ width: '50%' }}>
                                                <label style={{ margin: '0' }}>preço</label>
                                                <hr style={{ margin: '2px 0' }} />
                                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{product.onSalePrice + ' R$'}</span>
                                            </span>
                                        </span>
                                    </span>
                                    <br />
                                    <span>
                                        <span style={{color: 'rgb(245, 71, 73)'}}>
                                            <i className="bi bi-clipboard" ></i> tipo
                                        </span>
                                        <br /> 
                                        <span style={{fontSize: '15px' , fontWeight: 'bold'}}>
                                        { 
                                            product.categoryId === "54bd475f-7438-49fb-9967-ef0d2ba32c46"?
                                            'Salgadinho de Milho'
                                            :product.categoryId === "219cbfd3-dc40-4547-ba16-b68ee3cbb758"?
                                            'Salgadinho de Trigo'
                                            :product.categoryId === "d34e4917-4cdb-442e-90e8-e68adc781807"?
                                            'Pipoca'
                                            :null
                                        }
                                        </span>  
                                    </span>
                                    {/* <span style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-archive"></i> estoque:
                                        </span>
                                        {Data.Store ? Data.Store : <span style={{ color: 'red' }}>- sem estoque -</span>}
                                    </span> */}
                                </span>
                            </span>
                        </>
                        : null}
                    <br />
                    <div onClick={() => { setModalProduct(false); setShopperId('-') }} className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button className='btn btn-light'>
                            fechar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal show={modalSearch}>
                <button onClick={() => setModalSearch(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <span
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'column',
                        justifyContent: 'spaceBetween',
                        width: '100%',
                        margin: '10px 0',
                        justifyContent: 'space-around',
                        justifyContent: 'center',
                        alignContent: 'center'
                    }}
                >
                    <span
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                            justifyContent: 'spaceBetween',
                            justifyContent: 'space-around',
                            padding: '14px',
                            justifyContent: 'center',
                            gap: '10px',
                            border: '1px #f6f6f6 solid'
                        }}
                    >
                        <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            <h5 className="" style={{ margin: 0 }}><i className="fa-solid fa-magnifying-glass"></i></h5>
                            <h5 className="text-primary" style={{ margin: 0 }}>Pesquisar Loja</h5>
                        </span>
                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                            {searchSteps === 'name' ?
                                <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                                    <input onChange={(e) => setProductNameSearch(e.target.value)} value={productNameSearch.length > 0?productNameSearch.length:''} placeholder="pesquisar por nome" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                                    <button className={`btn btn-light`} style={{ fontSize: 12 }} onClick={() => handleStoreFilter(searchValueType, productNameSearch)}>buscar</button>
                                </span>
                                : searchSteps === 'address' ?
                                    <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                                            <input placeholder="pesquisar por endereço" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                                            <select style={{ width: '120px', textAlign: 'center', height: 40, color: 'gray' }}>
                                                <option onClick={(e) => { setValueType('street') }} >rua</option>
                                                {/* <option>número</option> */}
                                                <option onClick={(e) => setValueType('neighborhood')}>bairro</option>
                                                <option onClick={(e) => setValueType('city')}>cidade</option>
                                            </select>
                                        </span>
                                        <button
                                            className={`btn btn-light`}
                                            style={{ fontSize: 12 }}>
                                            buscar
                                        </button>
                                    </span>
                                    : null}
                        </span>
                    </span>
                </span>
            </Modal>
            <span style={{zIndex: 9999 , width: '100%' , height: '100vh' , backgroundColor: 'rgba(41 ,180,226,0.6)' , position: 'absolute' , top: 0, right: 0, display: loading?'flex':'none' , justifyContent: 'center' , alignItems: 'center'}} >
                <i id="loading-arrow-in-circle" className="bi bi-arrow-clockwise" style={{color: 'white' , fontSize: 75}}></i>
            </span>
        </>
    )
}
export default MenuOut; 
